import { Program } from "../../services/api";

/**
 * What identifies the install Home's saved setup state (ticked steps, dismissed guides) belongs to. Uninstalling deletes the
 * program and a reinstall creates a new one, so its creation date tells installs apart. Kept as milliseconds: the persisted
 * program comes back with its dates revived as `Date` (`restoreDates`), and an ISO key would be revived too.
 */
export const homeInstallKey = (program: Program | null): string | null =>
  program?.id ? (program.createdAt ? String(new Date(program.createdAt).getTime()) : program.id) : null;
